import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGreyIconLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.1753 5.00001H9.3158L10.6728 0.943757C10.8103 0.46875 10.415 0 9.87529 0H4.92534C4.51285 0 4.16223 0.278127 4.10722 0.650007L3.00724 8.15002C2.94192 8.60002 3.32691 9.00003 3.82535 9.00003H7.90562L6.32096 15.0781C6.1972 15.5532 6.59594 16 7.12188 16C7.41062 16 7.68563 15.8625 7.83687 15.6251L13.8868 6.12501C14.2065 5.62813 13.8112 5.00001 13.1753 5.00001Z",
		fill: "#5C7080"
	})
});
export default SvgGreyIconLogo;
